import React, { useState, useEffect } from "react";
import apiService from "../../services/api/api.service";
import { Loader } from "lucide-react";

const CorporateActions = ({
  uniqueTitle = "capgemini-technology-services-buy-sell-unlisted-share-price",
}) => {
  const [corporateActions, setCorporateActions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiService.getProductByTitle(uniqueTitle);

        if (
          response &&
          response.success &&
          response.data &&
          response.data.corporateActions
        ) {
          setCorporateActions(
            response.data.corporateActions.filter(
              (action) => action.financialYear
            )
          );
        } else {
          throw new Error("Invalid data format");
        }
      } catch (error) {
        setError(`Failed to fetch data: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [uniqueTitle]);

  if (loading)
    return (
      <div className="p-4 text-center text-gray-700 text-sm md:text-base">
        <Loader className="animate-spin text-indigo-500 mb-4" size={36} />
      </div>
    );

  if (error)
    return (
      <div className="p-4 text-red-500 text-center text-sm md:text-base">
        {error}
      </div>
    );

  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto">
      <h1 className="text-lg sm:text-xl font-bold mb-4 text-gray-800">
        Corporate Actions
      </h1>
      <div className="overflow-x-auto">
        <table className="w-full text-xs sm:text-sm border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-2 py-1 sm:px-3 sm:py-2 text-center border-b border-gray-300 sticky left-0 bg-gray-100">
                Financial Year
              </th>
              <th className="px-2 py-1 sm:px-3 sm:py-2 text-center border-b border-gray-300">
                Particulars
              </th>
              <th className="px-2 py-1 sm:px-3 sm:py-2 text-center border-b border-gray-300">
                Record Date
              </th>
              <th className="px-2 py-1 sm:px-3 sm:py-2 text-center border-b border-gray-300">
                Ratio / Amount
              </th>
              <th className="px-2 py-1 sm:px-3 sm:py-2 text-center border-b border-gray-300">
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            {corporateActions.length === 0 ? (
              <tr>
                <td
                  colSpan="5"
                  className="px-2 py-1 sm:px-3 sm:py-2 text-center text-gray-500"
                >
                  No corporate actions available
                </td>
              </tr>
            ) : (
              corporateActions.map((action, index) => (
                <tr key={index} className="border-b border-gray-300">
                  <td className="px-2 py-1 sm:px-3 sm:py-2 text-center border-r border-gray-300 sticky left-0 bg-white">
                    {action.financialYear || "N/A"}
                  </td>
                  <td className="px-2 py-1 sm:px-3 sm:py-2 text-center">
                    {action.particulars || "N/A"}
                  </td>
                  <td className="px-2 py-1 sm:px-3 sm:py-2 text-center">
                    {action.recordDate
                      ? new Date(action.recordDate).toLocaleDateString("en-IN")
                      : "N/A"}
                  </td>
                  <td className="px-2 py-1 sm:px-3 sm:py-2 text-center">
                    {action.ratioRatesAmount || "N/A"}
                  </td>
                  <td className="px-2 py-1 sm:px-3 sm:py-2 text-center">
                    {action.remarks || "N/A"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CorporateActions;
